'use client';

import Image from 'next/image';
import { useState } from 'react';

const NextImage = ({ src, alt = '', loading = 'lazy', ...props }) => {
  const [img, setImg] = useState(src);
  return (
    <Image
      src={img}
      onError={() => setImg('/imgs/layout/placeholder-img.webp')}
      alt={alt}
      loading={loading}
      {...props}
    />
  );
};

export default NextImage;
